<script setup>
import { computed } from 'vue';
import ConfigurationRadioSelection from '../../ConfigurationRadioSelection';
import ConfigurationCheckSelection from '../../ConfigurationCheckSelection';
import SelectOptionInfo from '../../SelectOptionInfo';
import { useMainStore } from '../../../store/index.js';

import '../../../styles/configurator-section.css';
import '../../../styles/configurator-selection.css';

const store = useMainStore();

const emit = defineEmits(['select']);

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
  images: {
    type: Object,
    default: null,
  },
});

const interiorstylingPackage = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'interiorstylingPackage');
});
const infotainmentPackage = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'infotainmentPackage');
});
const comfortPackage = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'comfortPackage');
});
</script>

<template>
  <section
    v-if="props.items"
    id="styling-comfort"
    class="configurator-section"
  >
    <h2>{{ $i18n('stylingComfortHeaderTitle') }}</h2>
    <div class="configurator-selection">
      <div
        class="configurator-selection__options"
        :class="{ 'justify-content-center': true }"
      >
        <SelectOptionInfo
          v-if="interiorstylingPackage"
          :option="interiorstylingPackage.options[0]"
          :selected="true"
          :show-gap-above-description="true"
        />
      </div>
    </div>
    <div class="configurator-section__image">
      <img
        :src="props.images?.dashboard"
        alt="Truck - front side view"
      >
      <img
        :src="props.images?.interior"
        alt="Truck - front side view"
      >
    </div>
    <h3>{{ $i18n('extras') }}</h3>
    <div class="configurator-section__row">
      <div class="configurator-selection">
        <div class="configurator-selection__checkoption">
          <SelectOptionInfo
            v-if="infotainmentPackage"
            :option="infotainmentPackage.options[0]"
            :checkbox="infotainmentPackage.selectionType === 'checkbox'"
            :selected="true"
            :show-gap-above-description="true"
          />
        </div>
      </div>
      <div class="sdds-divider-dark-vertical" />
      <div class="configurator-selection">
        <div
          class="configurator-selection__checkoption"
        >
          <SelectOptionInfo
            v-if="comfortPackage"
            :option="comfortPackage.options[0]"
            :checkbox="comfortPackage.selectionType === 'checkbox'"
            :selected="true"
            :show-gap-above-description="true"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
  .configurator-section__image {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 2em;
    max-width: 100%;
  }
  .configurator-section__image img {
    width: 40%;
  }
  .sdds-divider-dark-vertical {
    height: var(--sdds-spacing-layout-128);
    align-self: center;
  }
  .configurator-selection__checkoption {
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: 30em;
    height: 100%;
    width: 100%;
  }

  @media only screen and (max-width: 1000px) {
    .configurator-section__image {
      gap: 1em;
      max-width: 90%;
    }
    .sdds-divider-dark-vertical {
      display: none;
    }
    .configurator-section__row {
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 500px) {
    .configurator-section__image {
      flex-direction: column;
      align-items: center;
    }
    .configurator-section__image img {
      width: 90%;
    }
  }
</style>
